<template>
  <div class="coreTechnology">
    <umf-header style="position: absolute;"></umf-header>
    <div class="banner">
      <div class="row">
        <h4>
          <img src="~images/coreTechnology/text.png"
               alt="">
        </h4>
        <p>鑫毅数科在北美成立了加拿大AI实验室 </p>
        <p>与加拿大UBC大学区块链研究中心深入合作</p>
        <p>是北京理工大学区块链实验室的合作企业</p>
        <p>与齐鲁工业大学共建了区块链供应链金融研究所</p>
        <p>与延安大学共建了区块链应用及安全仿真实验室</p>
      </div>
    </div>
    <div class="center-page">
      <div class="nav-box clearfix" id="boxFixed" :class="{'is_fixed' : isFixed}">
        <div class="row">
          <ul>
            <li class="active">数据技术</li>
            <li>多方安全计算</li>
            <li>智慧营销</li>
            <li>智能金融风控服务</li>
            <li>数字人民币</li>
          </ul>
        </div>
      </div>
      <div class="page-box">
        
        <div class="page sm-one" style="display:block">
          <div class="row">
            <div class="item clearfix">
              <dl>
                <dd>
                  <h3>数据技术</h3>
                  <p>
                    鑫毅数科对数据全生命周期的每个阶段（计划、获取、存储、共享、维护、应用、消亡等）进行治理和规划，包含数据的采集、数据预处理、分布式存储、NoSQL数据库、数据仓库、机器学习、并行计算、可视化等，形成数据资产，进而直接对业务提供数据服务，通过数据驱动业务发展，做到“业务数据化、数据业务化” 。
                  </p>
                </dd>
                <dt>
                  <img src="~images/coreTechnology/item3.png" alt="">
                </dt>
              </dl>
            </div>
          </div>
        </div>
        <div class="page sm-two">
          <div class="row">
            <div class="item clearfix">
              <dl>
                <dt><img src="~images/coreTechnology/item1.png"
                       alt=""></dt>
                <dd>
                  <h3>多方安全计算</h3>
                  <p>
                    鑫毅数科自研5种加密算法，实现6种常用模型和17种操作算子，可覆盖90%建模场景，在金融领域覆盖营销推荐、鉴权核查、联合建模、联合征信等主流业务场景，有效解决数据隐私问题和数据孤岛问题。
                  </p>
                </dd>
              </dl>
            </div>
          </div>
        </div>
        <div class="page sm-three">
          <div class="row">
            <div class="img1">
              <img src="../../assets/images/coreTechnology/c1.png" alt="">
            </div>
            <div class="img2">
              <img src="../../assets/images/coreTechnology/c2.png" alt="">
            </div>
          </div>
        </div>
        <div class="page sm-four sm-two">
          <div class="row">
            <div class="img1">
              <img src="../../assets/images/coreTechnology/d1.png" alt="">
            </div>
            <div class="img2">
              <img src="../../assets/images/coreTechnology/d2.png" alt="">
            </div>
          </div>
        </div>
        
        <div class="page sm-five">
          <div class="row">
            <div class="img1">
              <img src="../../assets/images/coreTechnology/e.png" alt="">
            </div>
          </div>
        </div>

      </div>
    </div>
    <umf-footer></umf-footer>

  </div>
</template>

<script>
import UmfHeader from '@/components/umfHeader'
import umfFooter from '@/components/umfFooter'
import $ from 'jquery'
export default {
  components: {
    UmfHeader,
    umfFooter,
  },

  computed: {
  },
  data () {
    return {
      isFixed: false,
      offsetTop: 0,
      id: "",

    }
  },
  created () {
    if (this.$route.query.id) {
      this.id = this.$route.query.id

    }
  },
  mounted () {
    window.addEventListener('scroll', this.initHeight);
    this.$nextTick(() => {
      //获取对象相对于版面或由 offsetTop 属性指定的父坐标的计算顶端位置 
      this.offsetTop = $('#boxFixed').offset().top;
    })

    if (this.id !== '') {
      $('.center-page .nav-box ul li').eq(this.id).addClass('active').siblings().removeClass('active')

      if (this.id == 0) {
        $("body,html").animate({ scrollTop: $('.sm-one').offset().top - 45 }, 500)
      }
      if (this.id == 1) {
        $("body,html").animate({ scrollTop: $('.sm-two').offset().top - 45 }, 500)
      }
      if (this.id == 2) {
        $("body,html").animate({ scrollTop: $('.sm-three').offset().top - 45 }, 500)
      }
      if (this.id == 3) {
        $("body,html").animate({ scrollTop: $('.sm-four').offset().top - 45 }, 500)
      }
      if (this.id == 4) {
        $("body,html").animate({ scrollTop: $('.sm-five').offset().top - 45 }, 500)
      }

    }


    let _this = this
    $('.center-page .nav-box ul li').on('click', function () {
      $(this).addClass('active').siblings().removeClass('active')
      let index = $(this).index()
      console.log('点击了', index);
      
      if (index === 0) {
        $("body,html").animate({ scrollTop: $('.sm-one').offset().top - 45 }, 500)
      }
      if (index === 1) {
        $("body,html").animate({ scrollTop: $('.sm-two').offset().top - 45 }, 500)
      }
      if (index === 2) {
        $("body,html").animate({ scrollTop: $('.sm-three').offset().top - 45 }, 500)
      }
      if (index === 3) {
        $("body,html").animate({ scrollTop: $('.sm-four').offset().top - 45 }, 500)
      }
      if (index === 4) {
        $("body,html").animate({ scrollTop: $('.sm-five').offset().top - 45 }, 500)
      }

      // $('.page-box .page').eq(index).fadeIn().siblings().fadeOut()
    })
  },
  methods: {
    initHeight () {
      // 设置或获取位于对象最顶端和窗口中可见内容的最顶端之间的距离 (被卷曲的高度)
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      //如果被卷曲的高度大于吸顶元素到顶端位置 的距离
      this.isFixed = scrollTop > this.offsetTop ? true : false;
    }
  }
}
</script>
<style lang="scss" scoped>
.coreTechnology {
  height: 100%;
  .banner {
    width: 100%;
    height: 510px;
    background-image: url(~images/coreTechnology/banner.png);
    background-size: cover;
    position: relative;
    h4 {
      padding-top: 190px;
    }
    p {
      font-size: 16px;
      color: #ffffff;
      line-height: 30px;
      padding-left: 95px;
    }
  }

  .center-page {
    width: 100%;
    position: relative;

    @import "@/assets/css/common/table.scss";
    .nav-box {
      ul {
        li {
          width: 239px;
        }
      }
    }
  }
  .page {
    width: 100%;
    height: auto;
    position: relative;
    padding: 70px 0;
    padding-bottom: 157px;
    
    .item {
      dl {
        dt {
          float: left;
          padding-top: 160px;
        }
        dd {
          float: right;
          width: 475px;
          h3 {
            font-size: 34px;
            color: #3d4349;
            font-weight: normal;
            padding-top: 200px;
            text-align: right;
          }
          p {
            font-size: 16px;
            line-height: 36px;
            padding-top: 30px;
            color: #898282;
          }
        }
      }
    }
    &.sm-one {
      background: #f3f3f7;
      .item {
        dl {
          dt {
            float: right;
            padding-top: 160px;
          }
          dd {
            float: left;
            width: 475px;
            h3 {
              font-size: 34px;
              color: #3d4349;
              font-weight: normal;
              padding-top: 200px;
              text-align: left;
            }
            p {
              font-size: 16px;
              line-height: 36px;
              padding-top: 30px;
              color: #898282;
            }
          }
        }
      }
    }
    &.sm-three {
      background: #f3f3f7;
    }
    &.sm-four {
      background: #0b0824;
    }
    &.sm-two {
      background: #0b0925;
      .item {
        dl {
          dt {
            float: right;
            margin-left: 0px;
          }
          dd {
            float: left;
            width: 475px;
            h3 {
              color: #ffffff;
              text-align: left;
            }
            p {
              font-size: 16px;
              line-height: 36px;
              padding-top: 30px;
              color: #ffffff;
            }
          }
        }
      }
    }
    .sm-five {
      background: #f3f3f7;
    }
  }
}
</style>

